import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
@Component({
  selector: 'app-goods-info',
  template: `
	<div id="goodsInfor"  class="goods-infor" >
      <div class="goods-infor-title">商品名称（商品规格）（商品编码）*商品数量</div>
      <div *ngFor="let obj of goodsList;let idx = index" class="goods-infor-name">{{idx+1}}、{{obj}}</div>
	</div>
  `,
  styles: [`
  .goods-infor{
    position: absolute;
    display: none;
    background-color: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(5px);
    border-radius: 6px;
    box-shadow: 0px 0px 12px 0px rgba(79, 90, 103, 0.2);
    z-index: 1000;
    padding: 8px;
    padding-right: 10px;
    padding-left: 10px;
    color:white;
    line-height: 25px;
  }
  .goods-infor::after{
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        top: -10px;
        left: 25px;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid rgba(0, 0, 0, 0.7); 
        }
  .goods-infor .goods-infor-title{
     border-bottom: 1px dashed #ffffff;
     min-width:300px
  }
  .goods-infor .goods-infor-name{
     
  }
  `],
  encapsulation: ViewEncapsulation.None
})
export class GoodsInfoComponent implements OnInit {

  public goodsList=[]
  constructor(
    public http: FxDapHttpClient) {
  }

  ngOnInit(): void {
    //获取初始数据
  }
  visible: boolean;

  clickMe(): void {
    this.visible = false;
  }

  change(value: boolean): void {
    console.log(value);
  }

  public showGoodsInfor(e,goods,targetElement){

    this.goodsList= goods.split(",")
    var div = document.getElementById('goodsInfor');
    div.style.display = 'block';
    // 计算目标元素的位置
    const rect = targetElement.getBoundingClientRect();
    div.style.top = `${rect.bottom + window.scrollY-30}px`;
    div.style.left = `${rect.left + window.scrollX-210}px`;
  }

  // (mouseleave)="GoodscloseOpenWin($event)"
  public GoodscloseOpenWin($event){
    var div2 = document.getElementById('goodsInfor');
    div2.style.display = 'none';
  }
}